import axios, { AxiosResponse } from 'axios';
import { XData } from '@core/utils';
import { User } from '../types';

const endpoint = 'auth';

export interface SignInArgs {
  login: string;
  password: string;
}

export interface RefreshArgs {
  jwt: string;
  refreshToken: string;
}

const signIn = ({ login, password }: SignInArgs) =>
  axios
    .post<User>(`${endpoint}/login`, {
      Login: login,
      Pass: password,
      UserTyp: 'BackOffice'
    })
    .then<AxiosResponse<User>>(XData.deepLowercaseResData);

type UserWithAT = Omit<User, 'jwt'> & { accessToken: string };

const refreshJWT = ({
  jwt,
  refreshToken
}: {
  jwt: string;
  refreshToken: string;
}) =>
  axios
    .post<UserWithAT>(`${endpoint}/refresh`, {
      accessToken: jwt,
      refreshToken
    })
    .then<AxiosResponse<UserWithAT>>(XData.deepLowercaseResData);

export default { signIn, refreshJWT };
